import { Text } from '../../Text/Text';
import { TextLoader } from '../../Text/TextLoader';

export const FetchedAtText = ({
  fetchedAt,
  isLoading,
}: {
  fetchedAt?: string;
  isLoading: boolean;
}) => {
  if (isLoading) {
    return (
      <TextLoader
        backgroundColor="#e5e7eb"
        foregroundColor="#d1d5db"
        uniqueKey="fetched-at-loader"
        variant="none"
        width={120}
      />
    );
  }
  return (
    <Text as="span" variant="none">
      {fetchedAt}
    </Text>
  );
};
